/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SupportLinkCreate,
  SupportLinkDelete,
  SupportLinkOnAzure,
  SupportLinkUpdate,
} from '../models/index';
import {
    SupportLinkCreateFromJSON,
    SupportLinkCreateToJSON,
    SupportLinkDeleteFromJSON,
    SupportLinkDeleteToJSON,
    SupportLinkOnAzureFromJSON,
    SupportLinkOnAzureToJSON,
    SupportLinkUpdateFromJSON,
    SupportLinkUpdateToJSON,
} from '../models/index';

export interface ApiSupportLinkAddPostRequest {
    supportLinkCreate?: SupportLinkCreate;
}

export interface ApiSupportLinkDeleteDeleteRequest {
    supportLinkDelete?: SupportLinkDelete;
}

export interface ApiSupportLinkGetAllByLanguageCodeGetRequest {
    languageCode?: string;
}

export interface ApiSupportLinkUpdatePutRequest {
    supportLinkUpdate?: SupportLinkUpdate;
}

/**
 * 
 */
export class SupportLinkApi extends runtime.BaseAPI {

    /**
     */
    async apiSupportLinkAddPostRaw(requestParameters: ApiSupportLinkAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupportLinkOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/SupportLink/Add`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportLinkCreateToJSON(requestParameters['supportLinkCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportLinkOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiSupportLinkAddPost(requestParameters: ApiSupportLinkAddPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupportLinkOnAzure> {
        const response = await this.apiSupportLinkAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiSupportLinkDeleteDeleteRaw(requestParameters: ApiSupportLinkDeleteDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/SupportLink/Delete`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: SupportLinkDeleteToJSON(requestParameters['supportLinkDelete']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSupportLinkDeleteDelete(requestParameters: ApiSupportLinkDeleteDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiSupportLinkDeleteDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiSupportLinkGetAllByLanguageCodeGetRaw(requestParameters: ApiSupportLinkGetAllByLanguageCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SupportLinkOnAzure>>> {
        const queryParameters: any = {};

        if (requestParameters['languageCode'] != null) {
            queryParameters['language_code'] = requestParameters['languageCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/SupportLink/GetAllByLanguageCode`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportLinkOnAzureFromJSON));
    }

    /**
     */
    async apiSupportLinkGetAllByLanguageCodeGet(requestParameters: ApiSupportLinkGetAllByLanguageCodeGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SupportLinkOnAzure>> {
        const response = await this.apiSupportLinkGetAllByLanguageCodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiSupportLinkGetAllGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SupportLinkOnAzure>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/SupportLink/GetAll`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportLinkOnAzureFromJSON));
    }

    /**
     */
    async apiSupportLinkGetAllGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SupportLinkOnAzure>> {
        const response = await this.apiSupportLinkGetAllGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiSupportLinkUpdatePutRaw(requestParameters: ApiSupportLinkUpdatePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/SupportLink/Update`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportLinkUpdateToJSON(requestParameters['supportLinkUpdate']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSupportLinkUpdatePut(requestParameters: ApiSupportLinkUpdatePutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiSupportLinkUpdatePutRaw(requestParameters, initOverrides);
    }

}
